/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    bool, func, number, object,
    arrayOf, shape, string, array,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Media from 'react-media';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { compose } from 'recompose';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
// import Loading from '../../common/Loading';
import ErrorPage from '../../common/ErrorPage';
import AccountLeftMenu from '../../common/Desktop/AccountLeftMenu';
import AddressList from './AddressList';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import SortBy from './SortBy';
import configENV from '../../config';
import DesktopAddressBook from './DesktopAddressBook/DesktopAddressBook';
import { trackPage } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import { getAddressBookEntries } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import AccountHome from '../MyAccount/AccountHome';

const { PERSIST_KEY } = configENV;
const sortByList = ['Sort By', 'Name', 'Relationship'];

class AddressBook extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            selectedIndex: 0,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const {
            recipients, fetchAddressBook, addressBookEntries,
        } = this.props;
        if (addressBookEntries.length > 0) { // if address added from checkout address book, setting isAddressAddedFromCheckout=true to fetch all the latest addresses
            fetchAddressBook(recipients, true);
        } else {
            fetchAddressBook(recipients, false);
        }
    };

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    handleAddNewAddressClicked = () => {
        const { handleAddNewRecipient } = this.props;
        handleAddNewRecipient();
    };

    handleSortByClicked = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleSortByClosed = () => {
        this.setState({ anchorEl: null });
    };

    handleSortByMenuItemClick = (event, index) => {
        const { handleChangeSortBy } = this.props;
        this.setState({
            selectedIndex: index,
            anchorEl: null,
        }, () => {
            handleChangeSortBy(sortByList[index]);
        });
    };

    render() {
        const {
            recipients, breakpoint, userData,
            userProfile, featureFlags, error,
        } = this.props;
        const { anchorEl, selectedIndex } = this.state;
        const breakpointExpr = `(max-width: ${(breakpoint || CUSTOM_BREAKPOINTS.tabLandscape)}px)`;
        const headTags = (
            <GraphqlSeoHeadTags seoData={{
                page_title: 'Address Book',
                location: { pathname: '/account/address-book' },
            }}
            />
        );
        if (error === true || (error.errorMessage !== undefined && error.errorMessage !== '') || featureFlags['is-ross-error-page-enabled'] === true) {
            return (
                <>
                    {headTags}
                    <Media query={breakpointExpr}>
                        {(matches) => (
                            matches ? (
                                <div>
                                    <h1>
                                        <AccountHome />
                                        Address Book
                                    </h1>
                                    <ErrorPage userData={userData} />
                                </div>
                            ) : (
                                <Grid className="container" container>
                                    <AccountLeftMenu
                                        userProfile={userProfile}
                                        featureFlags={featureFlags}
                                    />
                                    <Grid item xs={10}>
                                        <ErrorPage userData={userData} />
                                    </Grid>
                                </Grid>
                            ))}
                    </Media>
                </>
            );
        }
        return (
            <>
                {headTags}
                <Media query={breakpointExpr}>
                    {(matches) => (
                        matches ? (
                            <div>
                                <h1>
                                    <AccountHome />
                                    Address Book
                                </h1>

                                <>
                                    <div className="row">
                                        <Button
                                            data-test="my-account-add-new-address"
                                            variant="contained"
                                            className="buttonHD margin-top"
                                            onClick={() => this.handleAddNewAddressClicked()}
                                        >
                                            Add New Address
                                        </Button>
                                    </div>
                                    <div className="display-none">
                                        <SortBy
                                            recipients={recipients}
                                            anchorEl={anchorEl}
                                            selectedIndex={selectedIndex}
                                            sortByList={sortByList}
                                            onSortByClicked={this.handleSortByClicked}
                                            onSortByClosed={this.handleSortByClosed}
                                            onSortByMenuItemClick={
                                                this.handleSortByMenuItemClick
                                            }
                                        />
                                    </div>

                                    <AddressList />
                                </>
                            </div>
                        ) : (
                            <>
                                <DesktopAddressBook userProfile={userProfile} featureFlags={featureFlags} />
                            </>
                        ))}
                </Media>
            </>
        );
    }
}

AddressBook.defaultProps = {
    fetchAddressBook: () => { },
    handleAddNewRecipient: () => { },
    handleChangeSortBy: () => { },
    recipients: [],
    userProfile: {},
    featureFlags: {},
    breakpoint: CUSTOM_BREAKPOINTS.tabLandscape,
    error: false,
};

AddressBook.propTypes = {
    recipients: arrayOf(
        shape({
            AddressBookEntryId: string,
            ContactId: number,
            NamePrefix: string,
            FirstName: string,
            MiddleInitial: string,
            LastName: string,
            NameSuffix: string,
            RelationShip: string,
            NickName: string,
            EmailAddress: string,
            LastUpdateDate: string,
            PhoneNumber: string,
            AlternatePhoneNumber: string,
            Fax: string,
            EmployerName: string,
            NumberOfAddresses: number,
            DateOfBirth: string,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    IsPartialMatch: bool,
                    IsUnknownAddress: bool,
                    Latitude_degrees: number,
                    Longitude_degrees: number,
                    IsBillingAddress: bool,
                    ContactId: number,
                }),
            ),
        }),
    ),
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }),
    featureFlags: object,
    fetchAddressBook: func,
    handleAddNewRecipient: func,
    handleChangeSortBy: func,
    breakpoint: number,
    addressBookEntries: array.isRequired,
    error: bool,
    userData: object.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    const isAuthenticated = state.member.auth.isAuthenticated || false;
    const userData = isAuthenticated ? ({
        firstName: state.member?.profile?.firstName || '',
        lastName: state.member?.profile?.lastName || '',
        email: state.member?.profile?.email || '',
    }) : {};
    return {
        toggleState: newState.toggleState,
        recipients: newState.recipients,
        addressBookEntries: getAddressBookEntries(state),
        error: newState.error,
        userData,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchAddressBook: (recipients, isAddressAddedFromCheckout) => dispatch(EventDispatcher.fetchAddressBook(recipients, isAddressAddedFromCheckout)),
    handleAddNewRecipient: () => dispatch(EventDispatcher.handleAddNewRecipient()),
    handleChangeSortBy: (sortBy) => dispatch(EventDispatcher.handleChangeSortBy(sortBy)),
});

const enhance = compose(
    trackPage({
        type: 'addressbook',
        name: 'MyAccount',
        accountPage: true,
    }),
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    withRouter,
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);
export default enhance(AddressBook);
